import { LANDING_DESCRIPTION, LANDING_TITLE } from '@/utils/messages';
import {
  getLastSignedInCustomerEmail,
  getSignedInCustomerEmail,
} from '@verifime/cognito-passwordless-auth';
import { Landing, SignUp, TSignUpProps } from '@verifime/components';
import { useEffect, useState } from 'react';

export default function SignUpView({
  signUpApiRequestAction,
  renderExtraEnterEmailChildren,
}: Readonly<Omit<TSignUpProps, 'initalEmail'>>) {
  const [email, setEmail] = useState('');

  useEffect(() => {
    let email = getSignedInCustomerEmail();
    if (!email) {
      // We'd like to pre-fill the last signed in customer email
      // to allow the customer customise the sign up email.
      email = getLastSignedInCustomerEmail();
    }
    setEmail(email);
  }, []);

  return (
    <Landing title={LANDING_TITLE} description={LANDING_DESCRIPTION}>
      <SignUp
        initalEmail={email}
        signUpApiRequestAction={signUpApiRequestAction}
        renderExtraEnterEmailChildren={renderExtraEnterEmailChildren}
      />
    </Landing>
  );
}
